module.exports = __webpack_public_path__ + "static/media/17.b938b98e.jpg";